// extracted by mini-css-extract-plugin
module.exports = {"reg":"Reg_reg__2bTi2","reg__text":"Reg_reg__text__2khwQ","reg__desc":"Reg_reg__desc__1JE81","reg__btn":"Reg_reg__btn__2OUDu"};